/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FullscreenIcon = /*#__PURE__*/ createSvgIcon(
  'FullscreenIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3.778 16.222h1.778a.86.86 0 01.633.256.86.86 0 01.255.633.86.86 0 01-.255.633.86.86 0 01-.633.256H2.889a.86.86 0 01-.633-.256.86.86 0 01-.256-.633v-2.667a.86.86 0 01.256-.633.86.86 0 01.633-.255.86.86 0 01.633.255.86.86 0 01.256.633v1.778zm12.444 0v-1.778a.86.86 0 01.256-.633.86.86 0 01.633-.255.86.86 0 01.633.255.86.86 0 01.256.633v2.667a.86.86 0 01-.256.633.86.86 0 01-.633.256h-2.667a.86.86 0 01-.633-.256.86.86 0 01-.255-.633.86.86 0 01.255-.633.86.86 0 01.633-.256h1.778zM3.778 3.778v1.778a.86.86 0 01-.256.633.86.86 0 01-.633.255.86.86 0 01-.633-.255A.86.86 0 012 5.556V2.889a.86.86 0 01.256-.633A.86.86 0 012.889 2h2.667a.86.86 0 01.633.256.86.86 0 01.255.633.86.86 0 01-.255.633.86.86 0 01-.633.256H3.778zm12.444 0h-1.778a.86.86 0 01-.633-.256.86.86 0 01-.255-.633.86.86 0 01.255-.633.86.86 0 01.633-.256h2.667a.86.86 0 01.633.256.86.86 0 01.256.633v2.667a.86.86 0 01-.256.633.86.86 0 01-.633.255.86.86 0 01-.633-.255.86.86 0 01-.256-.633V3.778z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default FullscreenIcon;
